import React from "react"
import { Handle } from "react-flow-renderer";
import { NodeCaption, NodeWindow, NodeContent, NodeWrapper } from "../";

export const NodeStart = React.memo((props) => {

  const { data } = props;
  const { bgColor, nombre = "", descripcion = "", onEdit, onRemove, input = true } = data;

  return (
    <NodeWrapper bgColor={bgColor}>
      <NodeWindow 
        caption={
          <NodeCaption title={nombre} onClickEdit={()=>onEdit(props)} removable={false} />
        }
      >
        {descripcion && 
          <NodeContent>
            {descripcion}
          </NodeContent>
        }
      </NodeWindow>
      <Handle
        type="source"
        position="right"
        style={{  backgroundColor: "red", transform: "translateY(0%)", top: "0px", bottom: "unset", borderRadius: "0px 5px 5px 0px", height: "100%", border: "0px solid white", width: "10px", right: "-8px"  }}
        isConnectable={true}
        isValidConnection={(connection) => true}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
    </NodeWrapper>
  );
});
